import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import SelectGroup from '../../../components/inputs/select/grouped/select-group';
import { FormProps } from '../../../shared/interfaces/form';

interface FormSelectGroupProps {
  item: FormProps;
  index: number;
  baseId: string;
  errors: any;
  control: any;
  isDisabled: boolean;
  setValue: (name: string, value: any) => void;
  getValues: (name?: string | string[]) => any;
}

const FormSelectGroup = ({
  item,
  index,
  baseId,
  errors,
  control,
  isDisabled,
  setValue,
  getValues
}: FormSelectGroupProps) => {
  const [isDisabledSelect, setIsDisabledSelect] = React.useState(false);
  
  const handleCustomChange = (value: any, onChange: any) => {
    onChange(value);
    
    // Aqui você pode adicionar lógica customizada baseada no item.name
    // Similar ao handleCustomChange do FormInput
    if (item.name === 'category') {
      // Exemplo de lógica customizada
    }
  };

  useEffect(() => {
    const page = window.location.hash.split('/')[1];

    if(page.toLocaleLowerCase().includes('list')) {
      setIsDisabledSelect(true);
    }
  }, []);

  return (
    <Controller
      key={`select-group-${index}-${baseId}`}
      name={item.name}
      control={control}
      defaultValue={item.value || ''}
      rules={item.rules}
      render={({ field }) => (
        <div className={`form-input-wrapper ${item.fullWidth ? 'full-width' : ''}`}>
          <SelectGroup 
            data={item.options?.data || []}
            placeholder={item.placeholder}
            error={errors[item.name]?.message}
            width={item.width}
            height={item.height}
            disabled={item.disabled || isDisabledSelect || isDisabled}
            value={field.value}
            onChange={(value: any) => handleCustomChange(value, field.onChange)}
          />
        </div>
      )}
    />
  );
};

export default FormSelectGroup;